import React from "react";
import { style, classes } from "../common/docs.st.css";
// Import StyleGuide related
import Layout from "../components/Layout/Layout";
import ReadMeRenderer from "../components/ReadMeRenderer/ReadMeRenderer";

interface IndexProps {
  className?: string;
  path?: any;
}

const Index = ({ path, className }: IndexProps) => {
  return (
    <Layout
      className={style(classes.root, className)}
      componentMenu={path === "docs" ? false : true}
    >
      <ReadMeRenderer path={path} />
    </Layout>
  );
};

export default Index;
